<template>
<div>
  <v-layout @click="logout()">
    <div style="position:relative; margin-right:10px">
    <v-tooltip bottom color="secondary">
      <h2 slot="activator">Team</h2>
      <span style="color:#23a6d5">The experience is reset every day</span>
    </v-tooltip>
    </div>
  </v-layout>
  <v-layout mt-2>
    <v-progress-circular style="margin-right:10px" v-if="!team" :size="40" :width="4" indeterminate color="secondary"></v-progress-circular>
    <template v-else>
        <div style="display:inline-block" v-for="(teamMember, index) in teamSorted" :key="index" @click="openModalNotificationMessage(teamMember, index)">
          <div style="position:absolute;margin-top:0px">
            <div class="avatar" :style="{ 'background-image':'url('+ teamMember.photoURL +')'}"></div>
          </div>
          <div style="position:relative; margin-right:10px">
            <v-tooltip v-if="!teamMember.endpoint" bottom color="secondary">
              <v-progress-circular slot="activator"  color="secondary" size="40" :rotate="rotate" :value="teamMember.experience/3"></v-progress-circular>
              <span style="color:#23a6d5">{{teamMember.displayName}}: {{teamMember.experience}}xp</span>
            </v-tooltip>
            <v-progress-circular v-else  color="secondary" size="40" :rotate="rotate" :value="teamMember.experience/3"></v-progress-circular>
          </div>
          <div class="message" v-if="teamMember.endpoint"><v-icon style="font-size: 10px;margin-top:-8px;" color="primary">message</v-icon></div>
          <div class="rank" v-if="index==0 && teamMember.experience>0">1st<v-icon v-if="teamMember.endpoint" style="font-size: 10px;margin-left:3px;margin-right:-2px" color="primary">message</v-icon></div>
          <div class="rank" v-if="index==1 && teamMember.experience>0">2nd<v-icon v-if="teamMember.endpoint" style="font-size: 10px;margin-left:3px;margin-right:-2px" color="primary">message</v-icon></div>
          <div class="rank" v-if="index==2 && teamMember.experience>0">3rd<v-icon v-if="teamMember.endpoint" style="font-size: 10px;margin-left:3px;margin-right:-2px" color="primary">message</v-icon></div>
          <ModalNotificationMessage v-if="notificationGranted"/>
        </div>
    <!--div id="linker" class="hidden-xs-only elevation-1" @click="share" :value="'https://antibideforever.firebaseapp.com/'+user.team" style="cursor:pointer;background-color: white;border-radius: 25px;text-align: center;padding-top: 9px;width: 60px;color: #23a6d5;height: 40px;">+<span style="margin-bottom:-5px">ADD</span></div-->
      <social-sharing class="hidden-sm-and-up" v-if="user" :url="'https://antibideforever.firebaseapp.com/signin/'+user.team" inline-template>
        <network network="whatsapp">
          <div class="elevation-1" style="cursor:pointer;background-color: white;border-radius: 25px;text-align: center;padding-top: 9px;width: 60px;color: #23a6d5;height: 40px;">+<span style="margin-bottom:-5px">ADD</span></div>
        </network>
      </social-sharing>
    </template>
  </v-layout>
</div>
</template>

<script>
export default {
  name: "Team",
  data() {
    return {
      displayName: "",
      rotate: -90,
      max: 30
    };
  },
  components: {
    ModalNotificationMessage: () =>
      import("@/components/ModalNotificationMessage")
  },
  computed: {
    notificationGranted() {
      if (Notification.permission == "granted") {
        return true;
      } else {
        return false;
      }
    },
    team() {
      return this.$store.getters.team;
    },
    user() {
      return this.$store.getters.user;
    },
    teamSorted() {
      //console.log(this.team)
      let array = Object.values(this.team).sort(function(a, b) {
        return a.experience < b.experience
          ? 1
          : b.experience < a.experience ? -1 : 0;
      });
      return array;
    }
  },
  methods: {
    logout: function() {
      /*this.$store.dispatch("logout");
      this.$store.commit("SET_USER", null);
      this.$router.push("/signin")*/
      //this.$store.dispatch("fetchNewMember");
    },
    openModalNotificationMessage(teamMember, index) {
      if (teamMember.endpoint) {
        this.$store.commit("SET_TEAM_MEMBER", teamMember);
        this.$store.commit("SET_MODAL_NOTIFICATION_MESSAGE", true);
      }
    }
    /*share() {
      this.$store.commit("SET_SNACKBAR", "Link copied to clipboard");
    }*/
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.avatar {
  height: 40px;
  width: 40px;
  background-position: center;
  background-size: 40px;
  position: relative;
  margin-right: 10px;
}
.rank {
  background-color: white;
  border-radius: 10px;
  height: 15px;
  width: 34px;
  margin-left: 6px;
  color: #23a6d5;
  text-align: center;
  font-size: 10px;
  margin-top: -15px;
  position: absolute;
}
.message {
  background-color: white;
  border-radius: 10px;
  height: 15px;
  width: 15px;
  margin-left: 26px;
  color: #23a6d5;
  text-align: center;
  margin-top: -15px;
  position: absolute;
}
.add {
  cursor: pointer;
  background-color: white;
  border-radius: 25px;
  text-align: center;
  padding-top: 9px;
  width: 60px;
  color: #23a6d5;
  height: 40px;
}

* {
  /*border: solid 1px red;*/
}
</style>



// WEBPACK FOOTER //
// src/components/Team.vue